import React, { Fragment } from 'react';
import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';

import { useApi } from 'Common/Hooks';
import { Main, Filter } from 'Containers';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { NutrientAnalysisFieldEnum as Fields } from 'Common/FieldEnum';
import { NUTRIENT_ANALYSIS_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  makeOptionsDataRemoveEmpty,
  makeOptionsDataWithEmpty,
} from 'Common/FormHelper';
import { withReportSubscription } from 'State/report/withReportSubscription';

import { NutrientAnalysisReportForm } from './components/NutrientAnalysisReportForm';

function NutrientAnalysisReportContainer({
  siteId,
  fromDate,
  toDate,
  mealType,
  cycleMenuId,
  changeCycleMenuId,
  nutritionStandardId,
  changeNutritionStandardId,
  getReport,
  reportFetching,
}) {
  const [
    { loading: loadingNutritionStandards, data: nutritionStandards },
    { request: nutritionStandardsRequest },
  ] = useApi([]);
  React.useEffect(() => {
    nutritionStandardsRequest.get('CycleMenu/GetNutritionStandards');
  }, []);

  const [
    { loading: loadingCycleMenus, data: cycleMenus },
    { request: cycleMenusRequest },
  ] = useApi(null);

  React.useEffect(() => {
    if (cycleMenuId !== null) {
      changeCycleMenuId(null);
    }

    if (nutritionStandardId) {
      changeNutritionStandardId(null);
    }

    // Get cycle menus after one of the cycle menu filters change.
    if (siteId && fromDate && toDate && mealType !== null) {
      cycleMenusRequest('CycleMenu/GetCycleMenus', {
        filter: {
          [Fields.Site]: siteId,
          [Fields.FromDate]: fromDate,
          [Fields.ToDate]: toDate,
          [Fields.MealType]: mealType,
          [Fields.GetActiveAndInactive]: true,
        },
      });
    }
  }, [siteId, fromDate, toDate, mealType]);

  const mainProps = () => {
    return {
      toolbox: {
        formName: NUTRIENT_ANALYSIS_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching,
          disabled: reportFetching,
        },
        shown: true,
      },
    };
  };

  const getNutritionStandardOptions = () =>
    cycleMenus && cycleMenus.length
      ? makeOptionsDataWithEmpty(
          nutritionStandards.filter((nutStd) =>
            cycleMenus.find(
              (cycleMenu) => cycleMenu.NutritionStdID === nutStd.Id
            )
          )
        )
      : [];

  const getCycleMenuOptions = () =>
    makeOptionsDataRemoveEmpty(
      !nutritionStandardId
        ? cycleMenus
        : cycleMenus.filter(
            (cycleMenu) => cycleMenu.NutritionStdID === nutritionStandardId
          )
    );

  const handleSubmit = async (values) => {
    getReport('Reports/USDANutrientAnalysis', values);
  };

  return (
    <Fragment>
      <Filter title="USDA Nutrient Analysis" />
      <Main {...mainProps()}>
        <NutrientAnalysisReportForm
          onSubmit={handleSubmit}
          nutritionStandardOptions={getNutritionStandardOptions()}
          noCycleMenusFound={cycleMenus != null && cycleMenus.length === 0}
          cycleMenuOptions={getCycleMenuOptions()}
          loadingNutritionStandards={loadingNutritionStandards}
          loadingCycleMenus={loadingCycleMenus}
          initialValues={{
            [Fields.SiteId]: null,
            [Fields.FromDate]: moment().day(1).format(DATE_FORMAT_FOR_UI),
            [Fields.ToDate]: moment().day(5).format(DATE_FORMAT_FOR_UI),
            [Fields.MealType]: 0,
            [Fields.NutritionStandard]: null,
            [Fields.CycleMenuId]: null,
            [Fields.Days]: 5,
          }}
        />
      </Main>
    </Fragment>
  );
}

const selector = formValueSelector(NUTRIENT_ANALYSIS_REPORT_FORM_NAME);

const mapDispatchToProps = {
  changeNutritionStandardId: (value) =>
    change(NUTRIENT_ANALYSIS_REPORT_FORM_NAME, Fields.NutritionStandard, value),
  changeCycleMenuId: (value) =>
    change(NUTRIENT_ANALYSIS_REPORT_FORM_NAME, Fields.CycleMenuId, value),
};

const mapStateToProps = (state) => ({
  siteId: selector(state, Fields.SiteId),
  fromDate: selector(state, Fields.FromDate),
  toDate: selector(state, Fields.ToDate),
  mealType: selector(state, Fields.MealType),
  nutritionStandardId: selector(state, Fields.NutritionStandard),
  cycleMenuId: selector(state, Fields.CycleMenuId),
});

const NutrientAnalysisReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(withReportSubscription(NutrientAnalysisReportContainer));

export { NutrientAnalysisReport };



// WEBPACK FOOTER //
// ./src/pages/reports/menus/NutrientAnalysisReport/NutrientAnalysisReport.js